import styled from 'styled-components';

import {
  Flex,
} from 'web-styled';

type IconProps = {
  isActive: boolean;
  isCompleted: boolean;
};

const Icon = styled(Flex).attrs({
  column: true,
  width: '40px',
  height: '40px',
  align: 'center',
  justify: 'center',
  shrink: 0,
})<IconProps>`
  border: 1px solid #757575;
  border-radius: 50%;
  cursor: pointer;

  img {
    width: 20px;
    height: 20px;
    display: none;
  }

  span {
    color: #757575;
  }

  svg {
    width: 20px;
    height: 20px;

    path {
      fill: #757575;
    }

    &.document path {
      fill: none;
      stroke: #757575;
    }
  }

  ${props => props.isActive && `
    border: 1px solid ${props.theme.colors.primary};
    background-color: ${props.theme.colors.primary};

    span {
      color: #ffffff;
    }

    svg {
      path {
        fill: #ffffff;
      }

      &.document path {
        stroke: #ffffff;
      }
    }
  `};

  ${props => props.isCompleted && !props.isActive && `
    border: 1px solid ${props.theme.colors.successLight};
    background-color: ${props.theme.colors.successLight};

    svg, span  {
      display: none;
    }

    img  {
      display: block;
    }
  `};
`;

export default Icon;
